






























































































































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeSalasEReservasStore from '@/components/Backoffice/Store/BackofficeSalasEReservasStore'
import { onlyNumber } from '@/utils/common'
import ModalBackofficeAgendarSala from '@/components/Backoffice/modais/ModalBackofficeAgendarSala.vue'
import { DataTablePagination } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import { useHospitais } from '@/composables'

@Component({
  components: {
    ModalBackofficeAgendarSala,
  },
})
export default class ViewBackofficeConfiguracaoDeSala extends Vue {
  readyState = false
  loadHospital: boolean = false
  loadRegraReservaSala: boolean = false
  loadEditRegraReservaSala: string = ''
  frequencias: Map<string, string> = new Map([
    ['NaoSeRepete', 'Não se repete'],
    ['Diario', 'Diário'],
    ['Semanal', 'Semanal'],
    ['Quinzenal', 'Quinzenal'],
    ['Mensal', 'Mensal'],
    ['Anual', 'Anual'],
  ])

  get loadingHospital() { return this.loadHospital }
  set loadingHospital(value: boolean) { this.loadHospital = value }

  get loadingRegraReservaSala() { return this.loadRegraReservaSala }
  set loadingRegraReservaSala(value: boolean) { this.loadRegraReservaSala = value }

  get loadingEditRegraReservaSala() { return this.loadEditRegraReservaSala }
  set loadingEditRegraReservaSala(value: string) { this.loadEditRegraReservaSala = value }

  get hospitalId() { return this.getBackofficeSalasEReservasStore.hospitalId }
  set hospitalId(value: string) { this.getBackofficeSalasEReservasStore.setHospitalId(value) }
  get hospitais() { return useHospitais.hospitaisByCurrentUser }

  fetchHospitais() { return useHospitais.loadHospitaisByCurrentUser() }

  get getBackofficeSalasEReservasStore() {
    return getModule(BackofficeSalasEReservasStore, this.$store)
  }

  get regrasReservSala() { return this.getBackofficeSalasEReservasStore.regrasReservaSala }

  get paginationRegraReservaSala() { return this.getBackofficeSalasEReservasStore.paginationRegraReservaSala }

  get searchRegrasReserva() { return this.getBackofficeSalasEReservasStore.searchRegrasReserva }
  set searchRegrasReserva(value: string) { this.getBackofficeSalasEReservasStore.setSearchRegrasReserva(value) }
  get searchSalaId() { return this.getBackofficeSalasEReservasStore.searchSalaId }
  set searchSalaId(value: string) { this.getBackofficeSalasEReservasStore.setSearchSalaId(value) }

  async hospitalChange(id: any) {
    this.loadingHospital = true
    this.getBackofficeSalasEReservasStore.clearSearchRegrasReserva()
    this.getBackofficeSalasEReservasStore.clearRegrasReservaSala()
    this.getBackofficeSalasEReservasStore.clearSearchSalaId()
    this.getBackofficeSalasEReservasStore.clearSalas()
    this.getBackofficeSalasEReservasStore.setHospitalId(id)

    await this.getBackofficeSalasEReservasStore.getAllConvenios()
    await this.getBackofficeSalasEReservasStore.getCbosAll()
    await this.getBackofficeSalasEReservasStore.getAllCentrosCirurgicosByHospital()
    await this.getBackofficeSalasEReservasStore.getAllSalasCirurgicasByHospital()

    const params: any = { hospitalId: id, ...this.getBackofficeSalasEReservasStore.paginationDefault }

    this.loadingRegraReservaSala = true
    await this.getBackofficeSalasEReservasStore.getAllRegraReservaSala(params)
    this.loadingRegraReservaSala = false
    this.loadingHospital = false
  }

  async resetBuscarRegraReservaSala(type: 'nome' | 'sala') {
    this.loadingRegraReservaSala = true
    if (type === 'sala') this.getBackofficeSalasEReservasStore.setSearchSalaId('')
    if (type === 'nome') this.getBackofficeSalasEReservasStore.setSearchRegrasReserva('')
    const request = await this.getBackofficeSalasEReservasStore.getAllRegraReservaSala(this.getBackofficeSalasEReservasStore.paginationRegraReservaSala)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao buscar regras ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingRegraReservaSala = false
      return
    }
    this.loadingRegraReservaSala = false
  }

  async buscarRegraReservaSala() {
    this.loadingRegraReservaSala = true
    const request = await this.getBackofficeSalasEReservasStore.getAllRegraReservaSala(this.getBackofficeSalasEReservasStore.paginationRegraReservaSala)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao buscar regras ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingRegraReservaSala = false
      return
    }
    this.loadingRegraReservaSala = false
  }

  regraReservaSalaPagedDebounce = _.debounce(param => this.getBackofficeSalasEReservasStore.getAllRegraReservaSala(param), 700)

  async updatePaginationRegraReservaSala(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingRegraReservaSala = true
    this.regraReservaSalaPagedDebounce(pagination)
    this.loadingRegraReservaSala = false
  }

  get regraReservaSalaHeaders() {
    return [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'Sala', value: 'salaId', sortable: false },
      { text: 'Horário', value: '', align: 'center', sortable: false },
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'Frequência', value: 'frequencia', sortable: false },
      { text: 'Recorrência', value: '', sortable: false },
      { text: 'Vinculado à', value: '', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  formatSalaNome(salaId: string) {
    const sala = this.getBackofficeSalasEReservasStore.salas.find((s: any) => s.id === salaId)

    if (sala) {
      if (sala.centroCirurgicoId) {
        const cc = this.getBackofficeSalasEReservasStore.centrosCirurgicos.find((c: any) => c.id === sala.centroCirurgicoId)
        const centroCirurgico = cc ? cc.nome : ''
        return `${sala.nome}${centroCirurgico ? ` [${centroCirurgico}]` : ''}`
      }
      return `${sala.nome}`
    }

    return ' - '
  }

  formatHorario(horaInicio: string, horaFim: string) {
    if (!horaInicio || !horaFim) return ' - '
    return `${horaInicio.substring(0, 5)} - ${horaFim.substring(0, 5)}`
  }

  formatRecorrencia(dataInicio: string, dataFim: string) {
    if (!dataInicio || !dataFim) return ' - '
    return `${moment(dataInicio).format('DD/MM/YYYY')} - ${moment(dataFim).format('DD/MM/YYYY')}`
  }

  formatFrequencia(key: string) {
    return this.frequencias.get(key) || ' -'
  }

  minimumOfThreeCharacters(text: string) {
    return ['', null, undefined].includes(text) || text.length < 3
  }

  onlyNumberUtil(event: any) {
    return onlyNumber(event)
  }

  isNotObject(item: any) {
    return typeof item !== 'object'
  }

  updateRegrasReserva() {
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Regra alterada com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
  }

  async adicionarRegraReservaSala() {
    this.getBackofficeSalasEReservasStore.clearRegraReservaSala()
    this.getBackofficeSalasEReservasStore.setMode('CREATE')
    this.getBackofficeSalasEReservasStore.setModal({ name: 'agendarSala', value: true })
  }

  async editarRegraReservaSala(id: string) {
    this.loadingEditRegraReservaSala = id
    const request = await this.getBackofficeSalasEReservasStore.getRegraReservaSalaById(id)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao buscar esta regra ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingEditRegraReservaSala = ''
      return
    }
    this.getBackofficeSalasEReservasStore.setMode('EDIT')
    this.getBackofficeSalasEReservasStore.setModal({ name: 'agendarSala', value: true })
    this.loadingEditRegraReservaSala = ''
  }

  async init() {
    await this.getBackofficeSalasEReservasStore.getAllMedicoByUsuarioId(this.$user.profile.sub)
    this.readyState = true
  }

  tabletSize: boolean = false

  onResize() {
    this.tabletSize = window.innerWidth < 768
  }

  async mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.init()
    EventBus.$emit('clearLoadingRequest')
  }

  beforeDestroy() {
    this.getBackofficeSalasEReservasStore.clearCbos()
    this.getBackofficeSalasEReservasStore.clearMedicos()
    this.getBackofficeSalasEReservasStore.clearOperadoras()
    this.getBackofficeSalasEReservasStore.clearRegrasReservaSala()
    this.getBackofficeSalasEReservasStore.clearSearchRegrasReserva()
    this.getBackofficeSalasEReservasStore.clearSearchSalaId()
    this.getBackofficeSalasEReservasStore.clearSalas()
    this.getBackofficeSalasEReservasStore.clearHospitalId()

    window.removeEventListener('resize', this.onResize)
  }
}
